import { Component, Input, OnChanges } from '@angular/core';
import { Account } from '../../shared/account.model';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';

export type columnType = 'paidOn' | 'paidBy' | 'supplierName' | 'amount' | 'category';

@Component({
  selector: 'app-account-expansion-table',
  templateUrl: './account-expansion-table.component.html',
  styleUrls: ['./account-expansion-table.component.scss'],
  animations: [
    trigger('openClose', [
      transition('* => *', [
        animate('0.25s', keyframes([
          style({ opacity: 0 }),
          style({ opacity: 1 }),
        ]),
        ),
      ])
    ])
  ]
})
export class AccountExpansionTableComponent implements OnChanges {

  @Input() accounts?: Account[];
  @Input() month = '';
  @Input() displayedColumns?: columnType[];
  @Input() panelTitle = '';

  animationTrigger = true;

  constructor() { }

  getTotalAmount(accounts: Account[]): number {
    return accounts.map(a => a.amount)
      .filter(a => a !== null)
      .reduce((acc: number, value) => acc + (value || 0), 0);
  }

  getRouterLink(account: Account) {
    if (this.month) {
      return `/accounts/${this.month}/${account.id}`;
    } else {
      return `/accounts/${account.id}`;
    }
  }

  ngOnChanges() {
    this.animationTrigger = !this.animationTrigger;
  }
}
